import { Flex, Input, IconButton } from "@chakra-ui/react";
import { useState } from "react";
import { FiSend } from "react-icons/fi";

export function ChatInput({ onSendText }) {
  const [message, setMessage] = useState("");

  const handleSend = () => {
    const text = message.trim();
    if (!text) return;
    onSendText(text);
    setMessage("");
  };

  const handleKeyUp = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Flex p="10px" gap="8px" borderTop="1px solid #eee">
      <Input
        placeholder="메시지 입력..."
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        onKeyUp={handleKeyUp}
      />

      <IconButton aria-label="Send" icon={<FiSend />} onClick={handleSend} />
    </Flex>
  );
}
